import { SiDiscord, SiX, SiInstagram, SiTiktok, SiYoutube, SiTwitch, SiGithub, SiSpotify, SiSoundcloud, SiSteam, SiTelegram, SiReddit, SiSnapchat, SiKick } from "react-icons/si";
import { Globe, Mail, Star, Crown, Flame, Zap, Heart, Gem, Skull, Ghost, Moon, Sparkles, Code, Music, Gamepad2, Shield, Rocket, Bug } from "lucide-react";

export const SOCIAL = {
  discord: { icon: SiDiscord, label: "Discord", color: "#5865F2" },
  twitter: { icon: SiX, label: "X / Twitter", color: "#ffffff" },
  instagram: { icon: SiInstagram, label: "Instagram", color: "#E4405F" },
  tiktok: { icon: SiTiktok, label: "TikTok", color: "#ffffff" },
  youtube: { icon: SiYoutube, label: "YouTube", color: "#FF0000" },
  twitch: { icon: SiTwitch, label: "Twitch", color: "#9146FF" },
  github: { icon: SiGithub, label: "GitHub", color: "#ffffff" },
  spotify: { icon: SiSpotify, label: "Spotify", color: "#1DB954" },
  soundcloud: { icon: SiSoundcloud, label: "SoundCloud", color: "#FF5500" },
  steam: { icon: SiSteam, label: "Steam", color: "#c7d5e0" },
  telegram: { icon: SiTelegram, label: "Telegram", color: "#26A5E4" },
  reddit: { icon: SiReddit, label: "Reddit", color: "#FF4500" },
  snapchat: { icon: SiSnapchat, label: "Snapchat", color: "#FFFC00" },
  kick: { icon: SiKick, label: "Kick", color: "#53FC18" },
  website: { icon: Globe, label: "Website", color: "#ffffff" },
  email: { icon: Mail, label: "Email", color: "#ffffff" },
};

export const BADGE_ICON = { star: Star, crown: Crown, flame: Flame, zap: Zap, heart: Heart, gem: Gem, skull: Skull, ghost: Ghost, moon: Moon, sparkles: Sparkles, code: Code, music: Music, gamepad: Gamepad2, shield: Shield, rocket: Rocket, bug: Bug };

export const SocialIcon = ({ platform, className = "h-5 w-5" }) => {
  const I = SOCIAL[platform]?.icon || Globe;
  return <I className={className} />;
};

export const BadgeIcon = ({ icon, className = "h-4 w-4", style }) => {
  const I = BADGE_ICON[icon] || Star;
  return <I className={className} style={style} />;
};
